import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import Nav from "../../components/Nav";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="px-4">
        <Nav />
      </div>
      <div className="container mt-16 mx-auto text-center text-white">
        <h1 className="text-4xl">Repeat First Down</h1>
        <p className="mt-4">
          You don't have permission for the page you're trying to access.
        </p>
        <div
          onClick={handleBack}
          className="flex flex-row justify-center mt-4 cursor-pointer hover:text-red-500"
        >
          <FontAwesomeIcon icon={faLeftLong} className="mr-2 text-4xl" />
          <div className="mt-1">Go back</div>
        </div>
      </div>
    </>
  );
}
